import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9i65h1cb: FaireBrandEntity = {
  token: "b_9i65h1cb",
  type: "brand",
  name: "Luxe B Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/ef284ada2094213cd8618499cbfbe60e9cbb3e14214fcbf712df0a74f0646621.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/02822a42f87794d76e5752350490edccc6c8084c49e325c32e91ad69bcf9bbd4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ef284ada2094213cd8618499cbfbe60e9cbb3e14214fcbf712df0a74f0646621.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/02822a42f87794d76e5752350490edccc6c8084c49e325c32e91ad69bcf9bbd4.png",
  location: "GA, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 262,
  isInsider: false,
  description:
    "Important Notice\n\nLuxe B Co. is excited to share that we now operate a new U.S. warehouse in Georgia, alongside two Canadian warehouses\n( Alberta and 1 newly opened in Ontario).\n\nPlease note:\nThere are no import fees or customs charges on your orders—even if Faire displays a message suggesting otherwise during checkout.\n\nIf you have any questions, feel free to message us anytime.\n— The Luxe B Co. Team\n\nTradeshows:\n\nExcited to share — by popular vote from our community, we are officially opening a permanent showroom in Atlanta. ✨\n\nYou can now find Luxe B Co. at:\n\nAmericasMart Building 1\nFloor 15 — Showroom E9\nTuesday, June 9 – Sunday, June 14\n\nHigh Point Market\nMarket Square\nBooth G-2027\nOctober & April\n\nLas Vegas Market\nWe moved\nNow in Building C, Floor 5\nBooth 596H\nJuly & January\n\n\n\nContact Us\n\n📞 Tuesday–Friday | 8:00 AM – 5:00 PM MST\n+[redacted-phone]\n\n📸 Follow us on Instagram\nOver 120,000 followers and access to all of our product videos and daily inspiration\n@luxebco\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:10.571Z",
    importedBy: "entity-db-cli",
  },
};
